import React, { Component } from 'react'
import LinkDropdown from '../../../Buttons/linkDropdown/'
import { Button, ButtonToolbar, MenuItem, DropdownButton, FormGroup, FormControl, InputGroup }from 'react-bootstrap'
import moment from 'moment'
import { translate } from "react-translate"

@translate("ActionBar")
export default class ActionBar extends Component {

  constructor (props) {
    super(props)

    this.state = {
      words: ''
    }
    this.handleChangeWords = this.handleChangeWords.bind(this);
  }

  handleChangeWords(event) {
    this.setState({words: event.target.value});
  }

  _handleSubmit(e){
    e.preventDefault();
    this.props.searchImisByWords(this.state.words)
  }

  componentWillMount() {
    this.props.loadDates()
  }

  componentWillUnmount() {
    this.props.resetFilters()
  }

  _renderMonth(date){
    moment.locale('es');
    var m = moment(date,'M');
    let day = moment(m).format('MMMM');
    return (
      <span>{day}</span>
    )
  }

  render () {

    const { onChangeYear, onChangeMonth, dates, year, month, t } = this.props

    let title_month = month ? this._renderMonth(month) : "Mes"
    let title_year = year ? year : "Año"
		var meses = [];

		if(dates.months && dates.months.length){
      meses = dates.months.slice().sort((a,b) => a-b)
		}

    return (
    	<div className="action-bar">
    		<div className="bar-options">
          <div className="box-views">
            <FormGroup>
            <InputGroup>
              <FormControl type="text" placeholder={t("Buscar_Contenidos")} value={this.state.words}  onChange={this.handleChangeWords}/>
              <InputGroup.Addon>
                <i className="fa fa-search" onClick={(e) => this._handleSubmit(e)}></i>
              </InputGroup.Addon>
            </InputGroup>
          </FormGroup>
          </div>
          <div className="box-selects">
            { (dates) ? (
              <div>
                <DropdownButton title={title_year} className="dropdown-mobile-friendly" id="dropdown-years" onSelect={ onChangeYear }>
                  {dates.years.map((item, index) =>
                    <MenuItem className="div-option" eventKey={item} key={index}>{item}</MenuItem>
                  )}
                </DropdownButton>
                <DropdownButton title={title_month} className="dropdown-mobile-friendly" id="dropdown-months" onSelect={ onChangeMonth }>
                  {meses.map((item, index) =>
                    <MenuItem className="div-option" eventKey={item} key={index}>{this._renderMonth(item)}</MenuItem>
                  )}
                </DropdownButton>
              </div>
              ) : ''
            }
          </div>
	      </div>
	      <div className="bar-divisor hidden-xs">
	      </div>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Imi/ActionBar/index.js